<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-1">
          </div>
          <div class="col-10">
            <div class="text-center mb-3">
            <span class="available-funds">Available Episode Funds:</span><span class="available-funds-amount"> $ {{ formatNumber(paymentDistribution.availableFunds) }}</span>
            </div>
            <b-form-group :label-cols="4" label="Participating Provider" label-align="right" :state="stateForField('organizationPayeeId')" :invalid-feedback="errorForField('organizationPayeeId')">
              <b-dropdown menu-class="dropdown-container" :text="payeeName"
                          :variant="hasError('organizationPayeeId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="payee in payees" :key="payee.organizationPayeeId"
                                 @click.prevent="setPayee(payee)">{{ payeeDisplayName(payee) }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4" label="Account" label-align="right" :state="stateForField('organizationAccountId')" :invalid-feedback="errorForField('organizationAccountId')">
              <span v-if="accounts.length === 0 && payeeName !== 'Select Payee' ">
                <div class="account-label">No Account on File</div>
              </span>
              <span v-if="accounts.length === 1">
              <div class="account-label">{{ transfer.account.name + ' (' + transfer.account.last4 + ')' }}</div>
              </span>
              <span v-if="accounts && accounts.length > 1">
              <b-dropdown  menu-class="dropdown-container" :text="accountName"
                          :variant="hasError('organizationAccountId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="account in accounts" :key="account.organizationAccountId"
                                 @click.prevent="setAccount(account)">{{ account.name + ' (' + account.last4 + ')'  }}
                </b-dropdown-item>
              </b-dropdown>
              </span>
            </b-form-group>
            <b-form-group class="covered-services-amount" :label-cols="4" label="Covered Service Amount" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group class="covered-services-amount-input" prepend="$"><b-form-input v-model="transfer.amount"></b-form-input></b-input-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'PayDistributionModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      paymentDistribution: {
        type: Object,
        required: false
      },

      paymentDistributionService: {
        type: Object,
        required: false
      },

      distributionAmount: {
        type: Number,
        required: true
      },

      bundleServiceId: {
        type: Number,
        required: false
      },
      bundleId: {
        type: Number,
        required: false
      },

      bundleServiceTypeId: {
        type: Number,
        required: false
      },

      account: {
        type: Object,
        required: false
      },

      payment: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        transfer: {
          organizationBundleServiceId: this.bundleServiceId,
          organizationBundleId: this.bundleId,
          organizationBundlePaymentDistributionServiceId: this.organizationBundlePaymentDistributionServiceId,
          amount: this.paymentDistributionService.originalAmount,
          organizationPayeeId: this.organizationPayeeId,
          bundleServiceTypeId: this.bundleServiceTypeId,
          organizationAccountId: this.organizationAccountId
        },
        distributionService: {

        },
        payeeName: 'Select Participating Provider',
        accountName: 'Select Account',
        payees: [],
        accounts: [],
        isSaving: false,
        searchTerm: '',
        matchedCodes: [],
        currentAccount: {}
      }
    },

    watch: {
      paymentDistributionService (newValue, oldValue) {
        this.clearAllErrors()
        if (newValue !== oldValue && newValue) {
          this.distributionService = _.clone(this.paymentDistributionService)
          this.transfer.amount = this.distributionService.originalAmount
          this.transfer.organizationAccountId = 0
          if (this.currentAccount.payee) {
            this.payeeName = this.currentAccount.payee.businessName
          } else {
            this.payeeName = 'Select a participating provider'
          }
          if (this.distributionService.totalPaid) {
            if (this.distributionService.originalAmount + this.distributionService.totalPaid < 0) {
              this.transfer.amount = 0
            } else {
              this.transfer.amount = this.distributionService.originalAmount + this.distributionService.totalPaid
            }
          }
          this.transfer.organizationBundlePaymentDistributionServiceId = this.paymentDistributionService.organizationBundlePaymentDistributionServiceId
          this.accountName = 'Select Account'
          this.accounts = {}
          this.currentAccount = {}

        }
      },

      account: function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          this.currentAccount = _.clone(newValue)
          this.transfer.account = _.clone(newValue)
          this.setPayee(this.currentAccount.payee)
          this.setAccount(this.currentAccount)
          this.accounts = this.payees.filter(payee => payee.organizationPayeeId === this.currentAccount.payee.organizationPayeeId)[0].accounts
        }
        if (newValue == null) {
          this.currentAccount = {}
          this.payeeName = 'Select Participating Provider'
          this.accountName = 'Select Account'
          this.transfer.account = {}
          this.transfer.organizationAccountId = 0
          this.accounts = {}
        }
      },

      distributionAmount (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.transfer.amount = _.clone(newValue)
        }
        this.transfer.amount = _.clone(oldValue)
      },

      visible (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.transfer.amount = this.paymentDistributionService.bundleService.amount
          this.transfer.organizationBundleId = this.bundleId
          this.transfer.organizationBundleServiceId = this.bundleServiceId
          this.transfer.organizationBundlePaymentDistributionServiceId = this.paymentDistributionService.organizationBundlePaymentDistributionServiceId
          if (this.currentAccount && this.currentAccount.payee) {
            this.transfer.organizationPayeeId = this.currentAccount.payee.organizationPayeeId
            this.transfer.organizationAccountId = this.currentAccount.organizationAccountId
          }
          this.transfer.bundleService = this.bundleServiceTypeId
        }
      }
    },

    computed: {
      title () {
        if (this.paymentDistributionService && this.paymentDistributionService.bundleService && this.paymentDistributionService.bundleService.serviceType.name) {
          return 'Edit Payment for ' + this.paymentDistributionService.bundleService.serviceType.name
        }

        return 'Edit Payment'
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()
        if (!this.transfer.amount) {
          this.addErrorForField('amount', 'You must enter an amount')
        }
        if (!this.transfer.account) {
          this.addErrorForField('organizationAccountId', 'You must select an account')
        }
        if (!this.transfer.organizationPayeeId) {
          this.addErrorForField('organizationPayeeId', 'You must select a payee')
        }

        return !this.hasErrors()
      },

      save () {
        if (this.isSaving) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.clearAllErrors()
        const service = this.distributionService
        const parameters = {
          organizationBundlePaymentDistributionServiceId: service.organizationBundlePaymentDistributionServiceId,
          organizationBundlePaymentDistributionId: service.organizationBundlePaymentDistributionId,
          originalAmount: this.transfer.amount,
          organizationBundleServiceId: service.organizationBundleServiceId,
          organizationAccountId: this.transfer.organizationAccountId,
          organizationPayeeId: this.transfer.organizationPayeeId
        }
        this.isSaving = true
        api.post('/Dashboard/PaymentDistribution/' + service.organizationBundlePaymentDistributionId + '/Service/' + service.organizationBundlePaymentDistributionServiceId, parameters).then(response => {
          this.$emit('paymentAdded')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to fund payment distribution: ' + error.message, error)
          }
        })
        this.isSaving = false
      },

      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return ''
      },

      loadPayees () {
        api.get('/Dashboard/Payees').then(response => {
          this.payees = response.data.filter(payee => payee.accounts.length > 0)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load payees: ' + error.message, error)
          }
        })
      },

      payeeDisplayName (payee) {
        let displayName = ''

        if (payee.businessName) {
          return payee.businessName
        }

        if (payee.users.length >= 1) {
          const payeeUser = payee.users[0].user

          if (payeeUser.firstName) {
            if (displayName) {
              displayName += ', '
            }
            displayName += payeeUser.firstName
          }

          if (payeeUser.lastName) {
            displayName += ' ' + payeeUser.lastName
          }
        }

        return displayName
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      setPayee (payee) {
        this.payeeName = this.payeeDisplayName(payee)
        this.transfer.organizationPayeeId = payee.organizationPayeeId
        this.accounts = payee.accounts
        if (this.accounts && this.accounts.length === 1) {
          this.setAccount(this.accounts[0])
        } else if (this.accounts && this.accounts.length > 1) {
          this.accountName = 'Select Account'
          this.transfer.account = null
        }
      },

      setAccount (account) {
        this.transfer.account = account
        this.transfer.organizationAccountId = account.organizationAccountId
        this.accountName = account.name + ' (' + account.last4 + ')'
      }
    },

    created () {
      this.$on('paymentConfirmed', this.paymentConfirmed)
    },

    mounted () {
      this.loadPayees()
    }
  }
</script>

<style scoped>
.available-funds {
  color: #2A84F4;
  font-weight: 500;
  font-size: 18px;
}
.available-funds-amount {
  font-weight: 500;
  font-size: 18px;
}

.covered-services-amount-input {
  width: 60%;
}

.account-label {
  font-size: 1rem;
  margin-top: 6px;
}
</style>
